import { useEffect } from 'react';
import { useRouter } from 'src/routes/hooks';
import { SplashScreen } from 'src/components/loading-screen';

export default function Redirect() {
  const router = useRouter();
  const nextUrlParam = new URLSearchParams({ to: window.location.pathname });

  useEffect(() => {
    router.replace(`/auth/signin?${nextUrlParam}`);
  }, []);

  // Splash rather than nothing: avoids a blank frame before the sign-in page renders.
  return <SplashScreen />;
}
